import React, {useState,useContext,createContext,useEffect,useRef,}  from 'react'
import {Form,Button,Container,Card,Alert,Row,Col,Tabs,Tab,Navbar} from 'react-bootstrap'
import axios from 'axios'
import {UserContext} from '../UserContext'

export default function CatalogueData() {

    const {accountingData,setAccountingData}=useContext(UserContext)
    const {activeTab,setActiveTab}=useContext(UserContext)
    const {exhibition,setExhibition}=useContext(UserContext)
    const {catalogueData,setCatalogueData}=useContext(UserContext)
    const {countriesListGr,countriesListEng}=useContext(UserContext)
    const {sendForm}=useContext(UserContext)

    const changeTab=(e)=>{
        e.preventDefault()
        window.scroll(0,0)
        if (exhibition.XP==0){
          setActiveTab('firms')
        }else{
          setActiveTab('b2b')
        }
        
    }




  return (

    
    <>
      <Alert variant='success'>
          <h4>ΣΤΟΙΧΕΙΑ ΚΑΤΑΛΟΓΟΥ // CATALOGUE DETAILS</h4>
          </Alert>
          <Form onSubmit={changeTab}>
          <Form.Group className="mb-3">
            <Form.Label><b>ΕΠΩΝΥΜΙΑ (ΓΙΑ ΤΟΝ ΚΑΤΑΛΟΓΟ ΣΤΑ ΕΛΛΗΝΙΚΑ)</b></Form.Label>
            <Form.Control maxLength={255} type="text" required value={catalogueData.CMSTRINGFIELD2}  onChange={(e)=>{setCatalogueData({...catalogueData, CMSTRINGFIELD2:e.target.value.toUpperCase()})}}   />
          </Form.Group>  


          <Form.Group className="mb-3">
            <Form.Label><b>COMPANY NAME (FOR CATALOGUE IN ENGLISH)</b></Form.Label>
            <Form.Control maxLength={255} type="text" required value={catalogueData.CMSTRINGFIELD3}  onChange={(e)=>{setCatalogueData({...catalogueData, CMSTRINGFIELD3:e.target.value.toUpperCase()})}}   />
          </Form.Group> 

          <Form.Group className="mb-3">
            <Form.Label><b>ΕΠΩΝΥΜΙΑ ΜΕΤΩΠΗΣ // NAME BOARD (for type 2/3 stands)</b></Form.Label>
            <Form.Control maxLength={255} type="text"  value={catalogueData.CMSTRINGFIELD4}  onChange={(e)=>{setCatalogueData({...catalogueData, CMSTRINGFIELD4:e.target.value.toUpperCase()})}}   />
          </Form.Group> 


          <Row>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΟΔΟΣ</b></Form.Label>
              <Form.Control maxLength={255} type="text" required value={catalogueData.USKATALOGOSODOS} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSODOS:e.target.value.toUpperCase()})}}/>
              </Form.Group>              
              </Col>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>STREET ADDRESS</b></Form.Label>
              <Form.Control maxLength={255} type="text" required value={catalogueData.USKATALOGOSODOSENG} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSODOSENG:e.target.value.toUpperCase()})}}/>
              </Form.Group>
              </Col>
            </Row>



            <Row>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΑΡΙΘΜΟΣ // STREET NUMBER</b></Form.Label>
              <Form.Control maxLength={64} type="text"  value={catalogueData.USKATALOGOSARITHMOS} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSARITHMOS:e.target.value.toUpperCase()})}}/>
              </Form.Group>              
              </Col>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΤΑΧ.ΚΩΔΙΚΑΣ // POSTAL CODE</b></Form.Label>
              <Form.Control maxLength={64} type="text" required value={catalogueData.USKATALOGOSTK} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSTK:e.target.value.toUpperCase()})}}/>
              </Form.Group>
              </Col>
            </Row>


            <Row>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΠΟΛΗ</b></Form.Label>
              <Form.Control maxLength={255} type="text" required value={catalogueData.USKATALOGOSPOLI} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSPOLI:e.target.value.toUpperCase()})}}/>
              </Form.Group>              
              </Col>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>CITY</b></Form.Label>
              <Form.Control maxLength={255} type="text" required value={catalogueData.USKATALOGOSPOLIENG} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSPOLIENG:e.target.value.toUpperCase()})}}/>
              </Form.Group>
              </Col>
            </Row>


            <Row>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΝΟΜΟΣ</b></Form.Label>
              <Form.Control maxLength={255} type="text" required value={catalogueData.USKATALOGOSNOMOS} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSNOMOS:e.target.value.toUpperCase()})}}/>
              </Form.Group>              
              </Col>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>REGION</b></Form.Label>
              <Form.Control maxLength={255} type="text" required value={catalogueData.USKATALOGOSNOMOSENG} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSNOMOSENG:e.target.value.toUpperCase()})}}/>
              </Form.Group>
              </Col>
            </Row>



            <Row>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΧΩΡΑ</b></Form.Label>
              {/* <Form.Control maxLength={255} type="text" required value={catalogueData.USKATALOGOSXORA} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSXORA:e.target.value.toUpperCase()})}}/>
               */}
              <Form.Select  required value={catalogueData.USKATALOGOSXORA} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSXORA:e.target.value})}}>
              <option value=''>[ΕΠΙΛΕΞΤΕ ΧΩΡΑ]</option>
              {countriesListGr}
            </Form.Select>             
              
              </Form.Group>              
              </Col>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>COUNTRY</b></Form.Label>
              {/* <Form.Control maxLength={255} type="text" required value={catalogueData.USKATALOGOSXORAENG} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSXORAENG:e.target.value.toUpperCase()})}}/> */}
              
              <Form.Select  required value={catalogueData.USKATALOGOSXORAENG} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSXORAENG:e.target.value})}}>
              <option value=''>[SELECT COUNTRY]</option>
              {countriesListEng}
            </Form.Select>                  
              
              </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΤΗΛΕΦΩΝΟ 1 // TELEPHONE 1</b></Form.Label>
              <Form.Control maxLength={255} type="text" required value={catalogueData.USKATALOGOS1THL} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOS1THL:e.target.value.toUpperCase()})}}/>
              </Form.Group>              
              </Col>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΤΗΛΕΦΩΝΟ 2 // TELEPHONE 2</b></Form.Label>
              <Form.Control maxLength={255} type="text" value={catalogueData.USKATALOGOS2THL} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOS2THL:e.target.value.toUpperCase()})}}/>
              </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>EMAIL</b></Form.Label>
              <Form.Control maxLength={255} type="email" required value={catalogueData.USKATALOGOSEMAIL} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSEMAIL:e.target.value})}}/>
              </Form.Group>              
              </Col>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>WEB SITE</b></Form.Label>
              <Form.Control maxLength={255} type="text" value={catalogueData.USKATALOGOSWEBSITE} onChange={(e)=>{setCatalogueData({...catalogueData, USKATALOGOSWEBSITE:e.target.value})}}/>
              </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
            <Form.Label><b>ΥΠΕΥΘΥΝΟΣ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON</b></Form.Label>
            <Form.Control maxLength={255} type="text" required value={catalogueData.USYPEYTHINOSSYMMETOXIS}  onChange={(e)=>{setCatalogueData({...catalogueData, USYPEYTHINOSSYMMETOXIS:e.target.value.toUpperCase()})}}   />
          </Form.Group> 



          <Row>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΤΗΛΕΦΩΝΟ ΥΠΕΥΘΥΝΟΥ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON TELEPHONE</b></Form.Label>
              <Form.Control maxLength={255} type="text" required value={catalogueData.USPHONEYPEYTHINOU} onChange={(e)=>{setCatalogueData({...catalogueData, USPHONEYPEYTHINOU:e.target.value.toUpperCase()})}}/>
              </Form.Group>              
              </Col>
              <Col>
              <Form.Group className="mb-3">
              <Form.Label><b>ΕΜΑΙL ΥΠΕΥΘΥΝΟΥ ΣΥΜΜΕΤΟΧΗΣ // CONTACT PERSON ΕΜΑΙL</b></Form.Label>
              <Form.Control maxLength={255} type="text" required value={catalogueData.USEMAILYPEUTHINOU} onChange={(e)=>{setCatalogueData({...catalogueData, USEMAILYPEUTHINOU:e.target.value})}}/>
              </Form.Group>
              </Col>
            </Row>


            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                <Form.Label><b>ΣΥΝΤΟΜΟ ΠΡΟΦΙΛ</b></Form.Label>
                <Form.Control maxLength={5000} as="textarea" rows={3} value={catalogueData.PROFILEGR} onChange={(e)=>{setCatalogueData({...catalogueData, PROFILEGR:e.target.value})}}/>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                <Form.Label><b>SHORT PROFILE</b></Form.Label>
                <Form.Control maxLength={5000} as="textarea" rows={3}  value={catalogueData.PROFILEENG} onChange={(e)=>{setCatalogueData({...catalogueData, PROFILEENG:e.target.value})}}/>
            </Form.Group>

          

            <>  
            <br/><br/><br/><br/>
            <Navbar bg="light" fixed="bottom" >
                <table width="100%"><tbody><tr>
                  
                <td align="left">
                  {accountingData.CMTIN && 
                    <Button variant="secondary" onClick={()=>sendForm(1)}>ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ // TEMPORARY SAVE</Button>
                  }
              

            </td>                  
                  <td align="right">
                <Button  variant="secondary" onClick={()=>{window.scroll(0,0);setActiveTab('accounting')}}>ΠΙΣΩ // BACK</Button>
                &nbsp;
                <Button type="submit" variant="success">ΕΠΟΜΕΝΟ // NEXT</Button>
                </td></tr></tbody></table>
            </Navbar> 
            </>


          {/* <p align="right">
          <Button  variant="secondary" onClick={()=>{window.scroll(0,0);setActiveTab('accounting')}}>ΠΙΣΩ // BACK</Button>
          &nbsp;
          <Button type="submit" variant="success">ΕΠΟΜΕΝΟ // NEXT</Button>
          </p>     */}

          </Form>
    
    </>
  
    )
}
